

window.addEventListener('load', function () {
  const selectorDefault = document.getElementById('payment-default');
  const selectorPrime = document.getElementById('payment-prime');
  const waitlistButtonsWrapper = document.querySelector('.waitlist-buttons-wrapper');
  const waitlistPrimeContainer = document.querySelector('.waitlist-prime-container');
  const waitlistRememberButton = document.querySelector('.waitlist-buttons-wrapper .remember');
  const waitingListModalId = document.querySelector('.waitlist-buttons-wrapper .remember')?.dataset?.modalId;
  const waitingListModal = document.getElementById(waitingListModalId);
  const buyButton = document.querySelector(`.ProductSubmitButton-Main`);
  const addToCartCopy = document.querySelector('#add-to-cart-copy');
  const paymentPrime = document.getElementById('payment-method-prime');
  const paymentDefault = document.getElementById('payment-method-default');

  function updatePrimeButtonContent() {
    if (addToCartCopy != null) {
      if (paymentPrime.checked) {
        mixpanel.track('[PRM] Produto - Clicou em Assine e Economize');
        addToCartCopy.innerHTML = 'Assine e economize';
        buyButton.style.background = 'linear-gradient(90deg, #F1D98A 0%, #DCA119 100%)';
        buyButton.style.color = '#260F0F';
        waitlistButtonsWrapper?.classList?.add('hidden');
        waitlistPrimeContainer?.classList?.remove('hidden');
      } else {
        addToCartCopy.innerHTML = 'Adicionar ao carrinho';
        buyButton.style.background = '#260F0F';
        buyButton.style.color = '#FFFFFF';
        waitlistButtonsWrapper?.classList?.remove('hidden');
        waitlistPrimeContainer?.classList?.add('hidden');
      }
    }
  }

  waitlistRememberButton?.addEventListener('click', function () {
    waitingListModal?.classList?.add('open');
  });

  if (selectorDefault != null) {
    selectorDefault.addEventListener('click', () => {
      if (paymentDefault != null) {
        paymentDefault.click();
      }
      updatePrimeButtonContent();
    });
  }

  if (selectorPrime != null) {
    selectorPrime.addEventListener('click', () => {
      if (paymentPrime != null) {
        paymentPrime.click();
      }
      updatePrimeButtonContent();
    });
  }
});

const caffeineHydrogenUrl = 'https://app.caffeinearmy.com.br/';
let selectedProductHandle = null;
const mountAndRedirectURL = (e, productHandle) => {
  e.preventDefault();
  if (this.selectedProductHandle == null) {
    this.selectedProductHandle = productHandle;
  }
  if (this.selectedProductHandle != null) {
    const formatedProductHandle = `${this.selectedProductHandle}`
      .replace('supercoffee-', '')
      .replaceAll('-', '_')
      .replace('_size', '')
    const stringUrl = `/assinatura/checkout?${formatedProductHandle}=1&plan=Anual`;
    window.location.href = `${caffeineHydrogenUrl}${stringUrl}`;
  }
}

function selectFormat(formatHandle, flavor, blockId, variantId, productId) {
  const allFormats = document.querySelectorAll(`.format-card-carousel--${flavor}`);
  const currentFormat = document.getElementById(`item-${formatHandle}`);
  this.selectedProductHandle = formatHandle;
  const variantInput = document.getElementById(`input-variant--${blockId}`);
  const productIdInput = document.getElementById(`input-product-id--${blockId}`);
  if (variantInput != null && productIdInput != null) {
    variantInput.value = variantId;
    productIdInput.value = productId;
  }

  if (allFormats != null && allFormats.length) {
    allFormats.forEach((format) => {
      format.classList.remove('format-item-carousel-active');
    });
  }
  if (currentFormat != null) {
    currentFormat.classList.add('format-item-carousel-active');
  }

  // Handle quantity for PPB
  const quantityInput = document.getElementById(`Quantity-${blockId}`);
  if (formatHandle.includes('rtd')) {
    if (quantityInput != null) {
      quantityInput.value = 3;
    }
  } else {
    if (quantityInput != null) {
      quantityInput.value = 1;
    }
  }
}


function setPPBQuantity(quantity) {
  const quantityInput = document.querySelector('.quantity__input-ppb');
  if (quantityInput != null) {
    quantityInput.value = quantity;
  }

  const allQuantityButtons = document.querySelectorAll('.quantity__button-ppb');
  if (allQuantityButtons != null && allQuantityButtons.length > 0) {
    allQuantityButtons.forEach((button) => {
      if (button.id === `item-ppb_${quantity}`) {
        button.classList.add('format_active');
      } else {
        button.classList.remove('format_active');
      }
    });
  }
}

if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);
        this.input.min = min;

        if (max) {
          this.input.max = max;
        } else {
          this.input.removeAttribute('max');
        }
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        // this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner')?.classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

function defineFlavor(productData){
  window.scrollTo(0, 0);
  const productInfo = JSON.parse(productData);

  const inputVariant = document.getElementById('selectedProductVariantId')
  inputVariant.value = productInfo.variant_id;

  const inputHandle = document.getElementById('selectedHandle')
  inputHandle.value = productInfo.handle;

  const mainImage = document.querySelectorAll('.mainProductImage')
  mainImage.forEach((image) => {
      image.srcset = productInfo.image;
      image.src = productInfo.image;
    });

  const backgrounds = document.querySelectorAll('.bg-alt-forced')
  backgrounds.forEach((background) => {
      background.style.background = productInfo.cor_background;
  });

  const mainProductTitle = document.querySelectorAll('.mainProductTitle')
  mainProductTitle.forEach((title) => {
    title.innerHTML = productInfo.title;
  });

  const mainProductDescription = document.querySelector('.custom_product__description');
  mainProductDescription.innerHTML = productInfo.description;

  const prices = document.querySelectorAll('.mainProductPriceItem');
  prices.forEach((price) => {
    price.innerHTML = formatCurrency(productInfo.price);
  });

  const bottomImagesGrid = document.querySelector('.bottom-images-grid');
  bottomImagesGrid.innerHTML = productInfo.innerHTML = `
                <div class="item1-bottom"> <img src='${productInfo.media.at(0).src}' alt="product" fetchpriority="high" loading="eager"></div>
                <div class="item2-bottom"> <img src='${productInfo.media.at(1).src}'  alt="product" fetchpriority="high" loading="eager"></div>
                <div class="item3-bottom"> <img src='${productInfo.media.at(2).src}'  alt="product" fetchpriority="high" loading="eager"></div>
  `
  const defaultPayment = document.getElementById('payment-default');
  if(productInfo.is_prime_exclusive){
    const primePayment = document.getElementById('payment-method-prime');
    defaultPayment.classList.add('hidden-important');
    primePayment.click();
  }else{
    defaultPayment.classList.remove('hidden-important');
    defaultPayment.click();
  }
}
